import Axios from 'axios'
import { Dispatch } from 'redux'
import { ActionResponse, Id } from 'util/types/index'
import { Balance, BalanceTypes, Payment } from './types'

export function createBalance (userId: Id, form: any) {
  return async (dispatch: Dispatch): Promise<ActionResponse<number>> => {
    return Axios
      .post(`/balance/${userId}`, form)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success') {
          getBalance(userId)(dispatch)
        }
        return res
      })
  }
}

export function getBalance (userId?: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<number>> => {
    return Axios
      .get(userId ? `/balance/${userId}` : '/balance')
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: BalanceTypes.BALANCE_GET, payload: res.data })
        }
        return res
      })
  }
}

export function getBalanceList (params?: Record<string, string|number>) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Balance[]>> => {
    return Axios
      .get('/balance/list', { params })
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: BalanceTypes.BALANCE_LIST, payload: res.data, pagination: res.pagination })
        }
        return res
      })
  }
}

export function getPaymentList (userId: Id, params?: Record<string, string|number>) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Payment[]>> => {
    return Axios
      .get(`/payment/${userId}`, { params })
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: BalanceTypes.PAYMENT_LIST, payload: res.data })
        }
        return res
      })
  }
}
